import { createContext, useContext, useEffect, useReducer } from "react";
import axios from "../../api/axios";
import { LOADED, STATUS_NOT_LOADED } from "../../api/constant";
import { showTypeErrorFetch, alertSuccess, confirmDelete } from "../../utilities/alerts.utilities";
import { INITIAL_STATE, types, brandsReducer } from "../../reducers/inventory/brandsReducer";

export const BrandsModalContext = createContext({});

export const BrandsModalProvider = ({ children, onBrandsUpdated }) => {
  const [state, dispatch] = useReducer(brandsReducer, INITIAL_STATE);

  const setFieldFormBrand = (value, field) => {
    dispatch({ type: types.SET_FIELD_FORM_BRAND, payload: { value, name: field } });
  };

  const goToBrandEdit = (item_id) => {
    dispatch({ type: types.SET_EDIT_FORM_BRAND, payload: true });
    const selected = state.elements.find((item) => item.id === item_id);
    if (selected) {
      dispatch({
        type: types.EDIT_FORM_BRAND,
        payload: {
          id: selected.id,
          name: selected.name ?? "",
          description: selected.description ?? "",
        },
      });
    }
  };

  useEffect(() => {
    if (state.status === STATUS_NOT_LOADED) {
      axios()
        .get("inventory/getListBrands", { params: state.filter })
        .then(({ data }) => {
          const list = data.brands ?? data ?? [];
          const rows = data.rows ?? list.length;
          dispatch({
            type: types.BRANDS_LOADED,
            payload: { elements: Array.isArray(list) ? list : [], rows },
          });
        })
        .catch((e) => showTypeErrorFetch(e));
    }
  }, [state.status, state.filter.page, state.filter.limit]);

  const createBrandClick = () => {
    axios()
      .post("inventory/createBrand", {
        name: state.edit_brand.name,
        description: state.edit_brand.description || null,
      })
      .then(() => {
        dispatch({ type: types.RELOAD_INDEX_BRANDS });
        dispatch({ type: types.EDIT_FORM_BRAND, payload: INITIAL_STATE.edit_brand });
        dispatch({ type: types.SET_EDIT_FORM_BRAND, payload: false });
        alertSuccess("Marca creada correctamente");
        onBrandsUpdated?.();
      })
      .catch((e) => showTypeErrorFetch(e));
  };

  const editBrandClick = () => {
    axios()
      .put(`inventory/editBrand/${state.edit_brand.id}`, {
        name: state.edit_brand.name,
        description: state.edit_brand.description || null,
      })
      .then(() => {
        dispatch({ type: types.RELOAD_INDEX_BRANDS });
        dispatch({ type: types.EDIT_FORM_BRAND, payload: INITIAL_STATE.edit_brand });
        dispatch({ type: types.SET_EDIT_FORM_BRAND, payload: false });
        alertSuccess("Marca actualizada correctamente");
        onBrandsUpdated?.();
      })
      .catch((e) => showTypeErrorFetch(e));
  };

  const deleteBrandClick = (brand_id) => {
    confirmDelete(
      "¿Seguro que desea eliminar esta marca?",
      "Esta acción no se puede deshacer.",
      () => {
        axios()
          .delete(`inventory/deleteBrand/${brand_id}`)
          .then(() => {
            dispatch({ type: types.RELOAD_INDEX_BRANDS });
            if (state.edit_brand.id === brand_id) {
              dispatch({ type: types.EDIT_FORM_BRAND, payload: INITIAL_STATE.edit_brand });
              dispatch({ type: types.SET_EDIT_FORM_BRAND, payload: false });
            }
            alertSuccess("Marca eliminada correctamente");
            onBrandsUpdated?.();
          })
          .catch((e) => showTypeErrorFetch(e));
      }
    );
  };

  return (
    <BrandsModalContext.Provider
      value={[
        state,
        dispatch,
        {
          setFieldFormBrand,
          createBrandClick,
          goToBrandEdit,
          editBrandClick,
          deleteBrandClick,
        },
      ]}
    >
      {children}
    </BrandsModalContext.Provider>
  );
};

const useBrandsModal = () => useContext(BrandsModalContext)[0];
const useDispatchBrandsModal = () => useContext(BrandsModalContext)[1];
const useActionsBrandsModal = () => useContext(BrandsModalContext)[2];

export { useBrandsModal, useDispatchBrandsModal, useActionsBrandsModal };
